import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import useAuth from "src/hooks/useAuth/useAuth";
import cmsClient from "src/services/cmsClient";

const downloadAllObservationsByUser = async ({
	formId,
	userId
}: ExportCSVOptions) => {
	const url = "observations/reports/all-observations-by-user-form/";

	const data = { form_id: formId, user_id: userId };

	const response = await cmsClient.post(url, data);
	return response.data;
};

const useByUserObservationsReport = () => {
	const { user } = useAuth();

	const onSuccess = () => {
		toast.success(
			<CustomToast
				type="Success"
				message={`A link to your export (All Observations By User) has been generated. Check your mail inbox (${user?.emailAddress}) for the link.`}
			/>,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(downloadAllObservationsByUser, {
		onSuccess,
		onError
	});

	return mutation;
};

export default useByUserObservationsReport;
